/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sword_logo': {
    width: 16,
    height: 16,
    viewBox: '0 0 28 49',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M6.225 2.357a14 14 0 1115.55 23.285A14 14 0 016.225 2.357zm2.807 19.08a8.949 8.949 0 109.944-14.882 8.949 8.949 0 00-9.944 14.881zM14 30.052c4.97.03 9 4.083 9 9.054 0 4.97-4.03 8.976-9 8.947-4.97-.03-9-4.083-9-9.054 0-4.97 4.03-8.976 9-8.947z" _fill="#000"/>'
  }
})
